
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
* This file exports all enum related types from the schema.
*
* 🟢 You can import this file directly.
*/

;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();export const PropertyStaffStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE'
} as const

export type PropertyStaffStatus = (typeof PropertyStaffStatus)[keyof typeof PropertyStaffStatus]


export const WorkspaceInvitationStatus = {
  PENDING: 'PENDING',
  ACCEPTED: 'ACCEPTED',
  EXPIRED: 'EXPIRED',
  FAILED: 'FAILED'
} as const

export type WorkspaceInvitationStatus = (typeof WorkspaceInvitationStatus)[keyof typeof WorkspaceInvitationStatus]


export const UserRole = {
  ADMIN: 'ADMIN',
  USER: 'USER'
} as const

export type UserRole = (typeof UserRole)[keyof typeof UserRole]


export const SchedulerSourceType = {
  MANUAL: 'MANUAL',
  SCHEDULED: 'SCHEDULED',
  WEBHOOK: 'WEBHOOK'
} as const

export type SchedulerSourceType = (typeof SchedulerSourceType)[keyof typeof SchedulerSourceType]


export const SchedulerJobStatus = {
  PENDING: 'PENDING',
  RUNNING: 'RUNNING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED'
} as const

export type SchedulerJobStatus = (typeof SchedulerJobStatus)[keyof typeof SchedulerJobStatus]


export const ExecutionStatus = {
  PENDING: 'PENDING',
  RUNNING: 'RUNNING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED'
} as const

export type ExecutionStatus = (typeof ExecutionStatus)[keyof typeof ExecutionStatus]


export const NotificationPreference = {
  EMAIL: 'EMAIL',
  IN_APP: 'IN_APP',
  NONE: 'NONE'
} as const

export type NotificationPreference = (typeof NotificationPreference)[keyof typeof NotificationPreference]


export const Status = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  SUSPENDED: 'SUSPENDED',
  PENDING: 'PENDING'
} as const

export type Status = (typeof Status)[keyof typeof Status]


export const PricingTier = {
  FREEMIUM: 'FREEMIUM',
  PREMIUM: 'PREMIUM',
  STANDARD: 'STANDARD'
} as const

export type PricingTier = (typeof PricingTier)[keyof typeof PricingTier]


export const ViewStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE'
} as const

export type ViewStatus = (typeof ViewStatus)[keyof typeof ViewStatus]


export const ProviderType = {
  YARDI: 'YARDI',
  APP_FOOLIO: 'APP_FOOLIO',
  OPINIION: 'OPINIION',
  GADMIN: 'GADMIN',
  GMELIUS: 'GMELIUS',
  APPFOLIO_DATABASE: 'APPFOLIO_DATABASE',
  QUICKBOOKS: 'QUICKBOOKS',
  PODIUM: 'PODIUM',
  GOTO_CONNECT: 'GOTO_CONNECT',
  CALL_LINKS: 'CALL_LINKS',
  SHOWMOJO: 'SHOWMOJO',
  ASANA: 'ASANA',
  RENTVINE: 'RENTVINE',
  ZOOM: 'ZOOM',
  RENTENGINE: 'RENTENGINE'
} as const

export type ProviderType = (typeof ProviderType)[keyof typeof ProviderType]


export const DataProviderWebhookStatus = {
  PENDING: 'PENDING',
  ACTIVE: 'ACTIVE',
  FAILED: 'FAILED',
  INACTIVE: 'INACTIVE'
} as const

export type DataProviderWebhookStatus = (typeof DataProviderWebhookStatus)[keyof typeof DataProviderWebhookStatus]


export const DataProviderWebhookResourceType = {
  ASANA_PROJECT: 'ASANA_PROJECT',
  PODIUM_ORGANIZATION_CONNECTION: 'PODIUM_ORGANIZATION_CONNECTION'
} as const

export type DataProviderWebhookResourceType = (typeof DataProviderWebhookResourceType)[keyof typeof DataProviderWebhookResourceType]


export const WorkflowTriggerType = {
  DATA_CHANGE: 'DATA_CHANGE',
  USER_ACTION: 'USER_ACTION',
  SCHEDULED: 'SCHEDULED',
  API: 'API',
  MANUAL: 'MANUAL'
} as const

export type WorkflowTriggerType = (typeof WorkflowTriggerType)[keyof typeof WorkflowTriggerType]


export const WorkflowStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  DRAFT: 'DRAFT'
} as const

export type WorkflowStatus = (typeof WorkflowStatus)[keyof typeof WorkflowStatus]


export const GlAccountMappingStatus = {
  DRAFT: 'DRAFT',
  ACTIVE: 'ACTIVE'
} as const

export type GlAccountMappingStatus = (typeof GlAccountMappingStatus)[keyof typeof GlAccountMappingStatus]


export const AlertStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  DRAFT: 'DRAFT',
  COMPLETED: 'COMPLETED'
} as const

export type AlertStatus = (typeof AlertStatus)[keyof typeof AlertStatus]


export const WorkflowStepType = {
  NOTIFICATION: 'NOTIFICATION',
  API_CALL: 'API_CALL',
  DATA_UPDATE: 'DATA_UPDATE',
  APPROVAL: 'APPROVAL',
  CONDITION: 'CONDITION',
  TRIGGER_GENERATION: 'TRIGGER_GENERATION',
  DATA_SUMMARIZATION: 'DATA_SUMMARIZATION',
  DELAY: 'DELAY',
  CUSTOM: 'CUSTOM'
} as const

export type WorkflowStepType = (typeof WorkflowStepType)[keyof typeof WorkflowStepType]


export const NotificationType = {
  EMAIL: 'EMAIL',
  SMS: 'SMS',
  PUSH: 'PUSH',
  WEBHOOK: 'WEBHOOK',
  IN_APP: 'IN_APP'
} as const

export type NotificationType = (typeof NotificationType)[keyof typeof NotificationType]


export const NotificationStatus = {
  PENDING: 'PENDING',
  SENT: 'SENT',
  FAILED: 'FAILED',
  READ: 'READ',
  VIEWED: 'VIEWED',
  CLOSED: 'CLOSED'
} as const

export type NotificationStatus = (typeof NotificationStatus)[keyof typeof NotificationStatus]


export const VisualizationStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE'
} as const

export type VisualizationStatus = (typeof VisualizationStatus)[keyof typeof VisualizationStatus]


export const VisualizationType = {
  TABLE: 'TABLE',
  BAR_CHART: 'BAR_CHART',
  LINE_GRAPH: 'LINE_GRAPH',
  PIE_CHART: 'PIE_CHART',
  SCATTER_PLOT: 'SCATTER_PLOT',
  HEAT_MAP: 'HEAT_MAP',
  COLUMN_CHART: 'COLUMN_CHART',
  BUBBLE_CHART: 'BUBBLE_CHART',
  FUNNEL_CHART: 'FUNNEL_CHART',
  GANTT: 'GANTT',
  MAP: 'MAP',
  DATA_POINT: 'DATA_POINT',
  SANKEY_CHART: 'SANKEY_CHART',
  RADAR_CHART: 'RADAR_CHART',
  RADIAL_CHART: 'RADIAL_CHART',
  COMPOSED_CHART: 'COMPOSED_CHART',
  OTHER: 'OTHER'
} as const

export type VisualizationType = (typeof VisualizationType)[keyof typeof VisualizationType]


export const DataSourceType = {
  API_CALL: 'API_CALL'
} as const

export type DataSourceType = (typeof DataSourceType)[keyof typeof DataSourceType]


export const ViewType = {
  SYSTEM: 'SYSTEM',
  CUSTOM: 'CUSTOM'
} as const

export type ViewType = (typeof ViewType)[keyof typeof ViewType]


export const GoalPostType = {
  AVERAGE: 'AVERAGE',
  TOTAL: 'TOTAL'
} as const

export type GoalPostType = (typeof GoalPostType)[keyof typeof GoalPostType]


export const DataMigrationStatus = {
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  PENDING: 'PENDING'
} as const

export type DataMigrationStatus = (typeof DataMigrationStatus)[keyof typeof DataMigrationStatus]


export const SharedViewPermission = {
  PUBLIC: 'PUBLIC',
  INTERNAL: 'INTERNAL',
  RESTRICTED: 'RESTRICTED'
} as const

export type SharedViewPermission = (typeof SharedViewPermission)[keyof typeof SharedViewPermission]


export const SharedViewStatus = {
  ACTIVE: 'ACTIVE',
  EXPIRED: 'EXPIRED',
  REVOKED: 'REVOKED'
} as const

export type SharedViewStatus = (typeof SharedViewStatus)[keyof typeof SharedViewStatus]


export const SharedViewMode = {
  SIMPLE: 'SIMPLE',
  DETAILED: 'DETAILED'
} as const

export type SharedViewMode = (typeof SharedViewMode)[keyof typeof SharedViewMode]


export const CustomAgentSetupStatus = {
  DRAFT: 'DRAFT',
  ACTIVATING: 'ACTIVATING',
  ACTIVE: 'ACTIVE'
} as const

export type CustomAgentSetupStatus = (typeof CustomAgentSetupStatus)[keyof typeof CustomAgentSetupStatus]


export const AgentEventPhase = {
  STARTED: 'STARTED',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED'
} as const

export type AgentEventPhase = (typeof AgentEventPhase)[keyof typeof AgentEventPhase]


export const AgentEventCategory = {
  LIFECYCLE: 'LIFECYCLE',
  RUN: 'RUN',
  WAVE: 'WAVE',
  SKILL: 'SKILL',
  ACTION: 'ACTION',
  TOOL: 'TOOL',
  PROVISION: 'PROVISION'
} as const

export type AgentEventCategory = (typeof AgentEventCategory)[keyof typeof AgentEventCategory]


export const AgentType = {
  LLM_ANALYTICS: 'LLM_ANALYTICS',
  AUTOMATION_ORCHESTRATOR: 'AUTOMATION_ORCHESTRATOR',
  HYBRID_ORCHESTRATOR: 'HYBRID_ORCHESTRATOR'
} as const

export type AgentType = (typeof AgentType)[keyof typeof AgentType]


export const AgentTrigger = {
  MANUAL: 'MANUAL',
  SCHEDULED: 'SCHEDULED'
} as const

export type AgentTrigger = (typeof AgentTrigger)[keyof typeof AgentTrigger]


export const HybridWorkItemStatus = {
  PENDING: 'PENDING',
  RUNNING: 'RUNNING',
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED',
  UNASSIGNED: 'UNASSIGNED',
  CANCELLED: 'CANCELLED'
} as const

export type HybridWorkItemStatus = (typeof HybridWorkItemStatus)[keyof typeof HybridWorkItemStatus]


export const OrganizationAutomationInboxStatus = {
  PENDING_PROVISION: 'PENDING_PROVISION',
  ACTIVE: 'ACTIVE',
  DISABLED: 'DISABLED'
} as const

export type OrganizationAutomationInboxStatus = (typeof OrganizationAutomationInboxStatus)[keyof typeof OrganizationAutomationInboxStatus]


export const AutomationMailboxWatchStatus = {
  PENDING: 'PENDING',
  ACTIVE: 'ACTIVE',
  FAILED: 'FAILED'
} as const

export type AutomationMailboxWatchStatus = (typeof AutomationMailboxWatchStatus)[keyof typeof AutomationMailboxWatchStatus]


export const InboxIntakeStatus = {
  PROCESSED: 'PROCESSED',
  IGNORED: 'IGNORED',
  AMBIGUOUS: 'AMBIGUOUS',
  FAILED: 'FAILED'
} as const

export type InboxIntakeStatus = (typeof InboxIntakeStatus)[keyof typeof InboxIntakeStatus]


export const AgentMemoryType = {
  RUN_SUMMARY: 'RUN_SUMMARY',
  INSIGHT: 'INSIGHT',
  PATTERN: 'PATTERN',
  USER_FEEDBACK: 'USER_FEEDBACK',
  ORCHESTRATION_SNAPSHOT: 'ORCHESTRATION_SNAPSHOT'
} as const

export type AgentMemoryType = (typeof AgentMemoryType)[keyof typeof AgentMemoryType]


export const VerificationPurpose = {
  SIGN_IN: 'SIGN_IN',
  SIGN_UP: 'SIGN_UP',
  SHARED_VIEW: 'SHARED_VIEW',
  INVITATION_ACCEPT: 'INVITATION_ACCEPT'
} as const

export type VerificationPurpose = (typeof VerificationPurpose)[keyof typeof VerificationPurpose]
